import { Button, Flex, Loader, Stack, Text } from '@mantine/core';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useMyForm } from '../../../../../react-commons/hooks/useMyForm';
import type { Result } from '../../../../../react-commons/types/result';
import { Inputs } from '../../../../../react-commons/utils/form/inputs';
import { removeAllDockedDialogs, removeAllFileUploadTask } from '../../../persisted/global/globalActions';
import type { MutationErrorResponse } from '../../../resource/resources/validation/errorResponseResource';
import { loginSchema } from '../../authentication/loginSchema';
import { showNotification } from '../../util/showNotification';
import { onLoginAction } from './onLoginAction';

export const JwtLoginPage = ({
    login,
}: {
    login: (credentials: { username: string; password: string }) => Promise<Result<void>>;
}) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(removeAllFileUploadTask());
        dispatch(removeAllDockedDialogs());
    }, [dispatch]);

    const {
        form: {
            control,
            formState: { isSubmitting },
        },
        formNames,
        onSubmit,
    } = useMyForm({
        schema: loginSchema,
        defaultValues: {
            username: '',
            password: '',
        },
        submitHandler: async ({ username, password }) => {
            const authenticationResult = await login({ username, password });
            if (authenticationResult.success) {
                onLoginAction(username);
            } else {
                showNotification({
                    severity: 'error',
                    title: 'Authentication failed',
                    errorResponseResult: authenticationResult.error as MutationErrorResponse,
                });
            }
        },
    });

    return (
        <Flex className={'main-window-content'} align={'center'} justify={'center'}>
            <form onSubmit={onSubmit} style={{ width: '30%' }}>
                <Stack align={'end'}>
                    <Text>You are not logged in!</Text>
                    <Inputs.String
                        nullable={false}
                        readOnly={false}
                        control={control}
                        name={formNames.username}
                        label={'Username'}
                        placeholder={''}
                        autoFocus={true}
                    />
                    <Inputs.Secret readOnly={false} control={control} name={formNames.password} label={'Password'} />
                    <Button
                        type="submit"
                        disabled={isSubmitting}
                        leftSection={isSubmitting ? <Loader size="sm" /> : undefined}
                    >
                        Login
                    </Button>
                </Stack>
            </form>
        </Flex>
    );
};
